import { rest } from "msw";
import type { DeviceAdapterType } from "../adapters/DeviceAdapters.ts";
import type { DomainConfig } from "../config.ts";
import {
  AttributeDataType,
  type AttributeDataTypeType,
} from "../schemas/AttributeSchemas.ts";
import {
  DeviceTypeSchema,
  type DeviceTypeType,
} from "../schemas/DeviceSchemas.ts";
import {
  getApiUrlWithEndpoint,
  type BuildMockHandlersType,
} from "./handlers.ts";
import { DomainFaker, DomainMock } from "./utils.ts";

export const DeviceTypeMock = new DomainMock<
  DeviceTypeType,
  typeof DeviceTypeSchema
>(
  DeviceTypeSchema,
  () => {
    return {
      id: DomainFaker.en.string.alpha(10),
      name: DomainFaker.en.string.alpha(10),
      attributes: [
        {
          id: DomainFaker.en.string.alpha(10),
          name: DomainFaker.en.string.alpha(10),
          description: DomainFaker.en.string.alpha(10),
          data_type: DomainFaker.en.helpers.arrayElement(
            Object.values(AttributeDataType)
          ) as AttributeDataTypeType,
          is_required: DomainFaker.en.helpers.arrayElement([true, false]),
        },
      ],
    };
  },
  true
).fix();

export const EmissionsMonitorMock = new DomainMock<
  DeviceTypeType,
  typeof DeviceTypeSchema
>(
  DeviceTypeSchema,
  () => {
    return {
      id: "emissions_monitor",
      name: "Emissions Monitor",
      attributes: [
        {
          id: "height",
          name: "Height",
          description: "Height",
          data_type: "number",
          is_required: true,
        },
        {
          id: "provider",
          name: "Provider",
          description: "Provider",
          data_type: "string",
          is_required: true,
        },
        {
          id: "location",
          name: "Location",
          description: "Location",
          data_type: "geo_point",
          is_required: false,
        },
      ],
    };
  },
  true
).fix();

export const buildDeviceTypeHandlers: BuildMockHandlersType<
  DeviceAdapterType["types"]
> = (configData: DomainConfig) => {
  const { nodeURL: url } = configData;

  return {
    getList: rest.get(
      getApiUrlWithEndpoint({
        url,
        version: 1,
        endpoint: "/device_types",
      }),
      (req, res, ctx) => {
        const page = Number(req.url.searchParams.get("page"));
        const pageSize = Number(req.url.searchParams.get("pageSize"));
        const data = [EmissionsMonitorMock.generate()];

        return res(
          ctx.status(200),
          ctx.json({
            data,
            page_number: page,
            page_size: pageSize,
            total_entries: data.length,
            total_pages: 1,
          })
        );
      }
    ),
  };
};
